import { BaseService } from './base-service';

class DashboardService extends BaseService {
  /**
   *  工作台数据接口
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof DashboardService
   */
  //查询配置信息
  getOverviewCard(params) {
    return this.request({
      method: 'get',
      url: `/workbench/config`,
      params
    });
  }
  //更新配置信息
  updateSetting(params) {
    return this.request({
      method: 'post',
      url: `/workbench/updateConfig`,
      data: params
    });
  }
  //数据结果指标统计
  getCount(params) {
    return this.request({
      method: 'post',
      url: `/workbench/count`,
      params: { apiIndex: params?.apiIndex || 0 },
      data: params
    });
  }
  //折线图接口
  getCountLine(params) {
    return this.request({
      method: 'post',
      url: `/workbench/countLine`,
      params: { apiIndex: params?.apiIndex || 0 },
      data: params
    });
  }
  //获取商机阶段类型
  getOpportunityStageType(params) {
    return this.request({
      method: 'post',
      url: `/workbench/stageType`,
      data: params
    });
  }
  //商机漏斗接口
  getOpportunityChart(params) {
    return this.request({
      method: 'post',
      url: `/workbench/countOpportunityChart`,
      data: params
    });
  }
  //线索转化
  getClueCount(params) {
    return this.request({
      method: 'post',
      url: `/workbench/clue`,
      data: params
    });
  }
  //订单产品金额柱状图
  getOrderPrice(params) {
    return this.request({
      method: 'post',
      url: `/workbench/product`,
      data: params
    });
  }
  /**
   *  工作台数据概览-日程数
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof DashboardService
   */
  getSummarySchedule(params) {
    return this.request({
      method: 'post',
      url: `/home/summary/schedule`,
      params,
      data: params
    });
  }
  /**
   *  日程管理
   *
   * @author ylq
   * @param  {Object} data
   * @returns
   * @memberof DashboardService
   */
  getScheduleList(params) {
    return this.request({
      method: 'post',
      url: `/home/theSchedule`,
      // params,
      data: params
    });
  }

  /**
   * @author qsj
   * 看板获取租户列表
   */
  getContractOrgList(params) {
    return this.request({
      method: 'get',
      // url: `/dataBoard/getTenantListMock`,
      url: `/dataBoard/getTenantList`,
      params
    });
  }
  /**
   * @brief 获取核心看板数据
   */
  getCardIndicatorData(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getContractCoreTarget`,
      data
    });
  }

  /**
   * @author qsj
   * 合同-合同流转效率表
   */
  getContractCirculation(params) {
    return this.request({
      method: 'post',
      // url: `/dataBoard/getContractDataBoardTableMock`,
      url: `/dataBoard/getContractDataBoardTable`,
      data: params
    });
  }

  /**
   *
   * @author qsj
   * 合同流转效率表平均值、合同流转效率图
   */
  getContractAverage(params) {
    return this.request({
      method: 'post',
      // url: `dataBoard/getContractDataBoardChartMock`,
      url: `/dataBoard/getContractDataBoardChart`,
      data: params
    });
  }

  /**
   * @brief 获取AI整体指标看板数据
   */
  getAICardIndicatorData(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getAiQuotaOverallMetrics`,
      data
    });
  }
  /**
   * @brief AI额度统计-租户列表
   */
  getAIQuota4Tenant(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getAiQuotaTenantList`,
      data
    });
  }
  /**
   * @brief AI额度统计-租户消耗额度列表
   */
  getAIUseUp4Tenant(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getAiUsageLogDetail`,
      data
    });
  }

  /**
   * @brief 智能提取整体指标
   */
  getIEIndicatorData(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getSmartExtractOverallMetrics`,
      data
    });
  }
  /**
   * @brief 智能提取租户列表
   */
  getIETenantData(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getSmartExtractTenantList`,
      data
    });
  }
  /**
   * @brief 智能提取租户弹窗字段列表
   */
  getIETenantFieldList(data) {
    return this.request({
      method: 'POST',
      url: `/dataBoard/getSmartExtractFieldDetail`,
      data
    });
  }
}

export const dashboardService = new DashboardService();
